import { Component, Vue } from 'vue-property-decorator'
import creatEdit from './components/creatEdit.vue'
import ImportModal from './components/ImportModal.vue'
import CodeModel from '@/components/CodeModel/index.vue'
import { exportMaintainItem } from '@/api/api'
import { MaintainItemServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
const misp = new MaintainItemServiceProxy()
const crsp = new CodeRuleServiceProxy()

@Component({
  components: {
    creatEdit,
    ImportModal
  }
})
export default class MaintenanceProgram extends Vue {
  get columns() {
    return [
      { title: this.$t('actions'), dataIndex: 'actions', width: 150,
        customRender: (row,_record) => {
          return (
            _record.id &&
            <div style="">
              <a
                type="link"
                onClick={(e) => {
                  e.stopPropagation();
                  this.edit(_record);
                }}
                v-acl="page_business_maintenance_program_edit"
              >
                {this.$t("edit")}
              </a>
              <a-divider type="vertical" />
              <a-popconfirm
                title={this.$t("page_resource_pool_confirm_delete")}
                onConfirm={() => this.delete(_record)}
                okText={this.$t("yes")}
                cancelText={this.$t("no")}
              >
                <a
                  type="link"
                  onClick={(e) => e.stopPropagation()}
                  v-acl="page_business_maintenance_program_delete"
                  class="del-color"
                >
                  {this.$t("delete")}
                </a>
              </a-popconfirm>
            </div>
          );
        },
      },
      { title: this.$t('page_plan_maintenance_code'), dataIndex: 'code', width: 200, ellipsis: true },
      { title: this.$t('page_plan_maintenance_items'), dataIndex: 'name', width: 200, ellipsis: true },
      { title: this.$t('page_plan_maintenance_requirements'), dataIndex: 'requirement', width: 200, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', ellipsis: true }
    ]
  }
  
  selectedRowKeys = []
  data = []
  maintainList = []
  loading = false
  height = 300
  total = 0
  searchKey = ""
  paginationOrder = {
    pageSize: 30,
    current: 1
  }
  creatEditVisible = false
  importMaterialVisible = false
  isEdit = false
  editData = {}
  showPrint = false
  dataList = []

  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }
  
  created(){
    this.reload(true)
    this.getCodeRules()
  }

  onSearch(value){
    this.paginationOrder = {
      pageSize: 30,
      current: 1
    }
    this.selectedRowKeys = []
    this.searchKey = value
    this.getList()
  }
  async getCodeRules(){
    const res = await crsp.list('MaintainObject')
    this.maintainList = res
  }

  updated(){
    const div = document.body.clientHeight
    this.height = div - 250
  }

  getList(){
    this.loading = true
    misp.queryMaintainItemListPage(this.paginationOrder.current,this.searchKey,this.paginationOrder.pageSize).then(res =>{
    
      let dataLength = res.records.length;
      let copy = JSON.parse(JSON.stringify(res.records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }

      this.data = JSON.parse(JSON.stringify(copy));

      this.total = Number(res.total)
      this.loading = false
    }).catch(() =>{
      this.loading = false
    })
  }

  delete(record){
    const ids = [record.id]
    misp.deleteMaintainItem(ids).then(() =>{
      this.$message.success(this.$t('delete_success'))
      this.reload(true)
    })
  }

  addNew(){
    this.creatEditVisible = true
    this.isEdit = false
    this.editData = {}
  }

  edit(record){
    this.editData = record
    this.creatEditVisible = true
    this.isEdit = true
  }

  handleDelete(){
    misp.deleteMaintainItem(this.selectedRowKeys).then(() =>{
      this.$message.success(this.$t('delete_success'))
      this.selectedRowKeys = []
      this.reload(true)
    })
  }

  handleTableChange(data) {
    this.paginationOrder = {
      pageSize: 30,
      current: data
    }
    this.selectedRowKeys = []
    this.getList()
  }

  reload(value){
    this.importMaterialVisible = false
    this.creatEditVisible = false
    if(value){
      this.paginationOrder = {
        pageSize: 30,
        current: 1
      }
      this.searchKey = ""
      this.selectedRowKeys = []
      this.getList()
    }
  }

  onSelectChange(selectedRowKeys) {
    this.selectedRowKeys = selectedRowKeys
  }

  importMaterial(){
    this.importMaterialVisible = true
  }

  handleMenuClick(value){
    const data = {
      exportSelected: false,
      selectedRecords: [],
      keyWord: ''
    }
    if(value == 1){
      data.exportSelected = true
      data.selectedRecords = this.selectedRowKeys
      data.keyWord= this.searchKey
    } else {
      data.exportSelected = false
      data.selectedRecords = []
      data.keyWord= this.searchKey
    }
    exportMaintainItem(data).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_plan_maintenance_items')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }
  getDataList() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.data.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.code,
            name: item.name
          })
        }
      })
    })
  }

  printing(){
    this.getDataList()
    this.showPrint = true
  }

  cancel() {
    this.selectedRowKeys = []
    this.showPrint = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.showPrint = false
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  }

  cancelChooseArr(val) {
    this.selectedRowKeys = [];
  }

  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between; padding: 8px 8px 0 0;">
          <div>
            <a-button type="primary" onClick={() => this.addNew()} style="margin-right: 8px;">{ this.$t('create')}</a-button>
            <a-popconfirm
              title={this.$t("page_resource_pool_confirm_delete")}
              onConfirm={() => this.handleDelete()}
              okText={this.$t("yes")}
              cancelText={this.$t("no")}
            >
              <a-button type="danger" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;">{ this.$t('delete')}</a-button>
            </a-popconfirm>
            <a-button type="default" style="margin-right: 8px;" onClick={() => this.importMaterial()}>{ this.$t('page_business_import_material')}</a-button>
            <a-dropdown>
              <a-menu slot="overlay" onClick={value => this.handleMenuClick(value.key)}>
                <a-menu-item key={1} disabled={this.selectedRowKeys.length === 0}>
                  { this.$t('page_product_confirm_select_export') }
                </a-menu-item>
                <a-menu-item key={2} disabled={this.data.length === 0}>
                  { this.$t('page_product_confirm_search_export') }
                </a-menu-item>
              </a-menu>
              <a-button>{ this.$t('page_product_export')}<a-icon type="down" /> </a-button>
            </a-dropdown>
            <a-button
           style={{ marginLeft: "8px" }}
           disabled={this.selectedRowKeys.length === 0}
           onClick={this.printing}
          >
             {this.$t('page_print_code')}
          </a-button>
          </div>
          <div>
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_my_document_advanced') }</a-button> */}
            <a-input-search style="width: 200px" placeholder={this.$t('keyword')} enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%">
          <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            rowKey="id"
            loading={this.loading}
            scroll={{ y: this.height }}
            row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange,getCheckboxProps: this.getCheckboxProps }}
            chooseArr={this.selectedRowKeys}
            onCancelChooseArr={this.cancelChooseArr}
          >
          </ml-table>
          <a-pagination
            style="position:absolute;bottom: 4px;right: 20px"
            show-total={total => `${ this.showTotal(total) }`}
            current={ this.paginationOrder.current }
            pageSize={ this.paginationOrder.pageSize }
            total={ this.total }
            on-change={ this.handleTableChange }
            on-showSizeChange={ this.handleTableChange }
          />
        </div>
        {this.creatEditVisible ? 
          <creat-edit
            visible={this.creatEditVisible}
            onClose={value => this.reload(value)}
            data={this.editData}
            isEdit={this.isEdit}
            maintainList={this.maintainList}
          ></creat-edit>: null}
          
        {this.importMaterialVisible ? 
          <import-modal
            visible={this.importMaterialVisible}
            onClose={value => this.reload(value)}
          ></import-modal>: null}
          <code-model
          visible={this.showPrint }
          onCancel={this.cancel}
          dataList={this.dataList}
          onprint={this.handlerPrint}
          >
          </code-model>
      </blank-view>
    )
  }

}
